import React from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart2, BookOpen, LayoutDashboard, TrendingUp } from 'lucide-react';

const TABS = [
  { to: '/', label: 'Dashboard', Icon: LayoutDashboard, exact: true },
  { to: '/trades', label: 'Trades', Icon: TrendingUp },
  { to: '/journal', label: 'Journal', Icon: BookOpen },
  { to: '/analytics', label: 'Analytics', Icon: BarChart2 },
];

export default function BottomTabBar() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-900 border-t border-slate-800 flex">
      {TABS.map(({ to, label, Icon, exact }) => (
        <NavLink
          key={to}
          to={to}
          end={exact}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center py-2 gap-1 text-xs transition-colors ${
              isActive ? 'text-emerald-400' : 'text-slate-500 hover:text-slate-300'
            }`
          }
        >
          <Icon size={20} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
